import React from 'react';

export default class PageSeperator extends React.Component{
    render(){
        return <div className="separator-breadcrumb border-top"></div>
    }
}